export default __webpack_public_path__ + "static/media/down-arrow--white.aee3ee6e.svg";